import styled from "styled-components";
import {JackpotToastClockDefaultBox} from "./jackpot-toast-clock.default.box";

export const JackpotToastClockMrGreenBox = styled(JackpotToastClockDefaultBox)`
    
    background-color: transparent;
    color: ${props => props.theme.colors.textContrast};
    
    @media ${props => props.theme.mediaQuery.mAndBelow} {
        
    }
`;